import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUploadOutlined = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M8.25781 2.61719L10.6953 5.05469C10.8359 5.19531 10.8359 5.45312 10.6953 5.59375C10.5547 5.73438 10.2969 5.73438 10.1562 5.59375L8.375 3.78906V10C8.375 10.2109 8.1875 10.375 8 10.375C7.78906 10.375 7.625 10.2109 7.625 10V3.78906L5.82031 5.59375C5.67969 5.73438 5.42188 5.73438 5.28125 5.59375C5.14062 5.45312 5.14062 5.19531 5.28125 5.05469L7.71875 2.61719C7.85938 2.47656 8.11719 2.47656 8.25781 2.61719ZM3.5 3.25H4.25C4.4375 3.25 4.625 3.4375 4.625 3.625C4.625 3.83594 4.4375 4 4.25 4H3.5C3.07812 4 2.75 4.35156 2.75 4.75V13C2.75 13.4219 3.07812 13.75 3.5 13.75H12.5C12.8984 13.75 13.25 13.4219 13.25 13V4.75C13.25 4.35156 12.8984 4 12.5 4H11.75C11.5391 4 11.375 3.83594 11.375 3.625C11.375 3.4375 11.5391 3.25 11.75 3.25H12.5C13.3203 3.25 14 3.92969 14 4.75V13C14 13.8438 13.3203 14.5 12.5 14.5H3.5C2.65625 14.5 2 13.8438 2 13V4.75C2 3.92969 2.65625 3.25 3.5 3.25Z"
	})
});
const ForwardRef = forwardRef(SvgUploadOutlined);
export default ForwardRef;
